import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(document).on('click', '.dropdown-button__label', function () {
    const $currentDropdown = $(this).closest('.dropdown-button');
    $currentDropdown.toggleClass('dropdown-button--active');
    $('.dropdown-button').not($currentDropdown).removeClass('dropdown-button--active');
    return false;
  });

  $('html').click(function (e) {
    const $target = $(e.target);
    if (!$target.is('.dropdown-button__checkbox-item *, .dropdown-button__label')) {
      $('.dropdown-button').removeClass('dropdown-button--active');
    }
  });
});
